import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useBOMProjectStore } from "../../../hooks/bom_project";
import System from "../../../helper/system";
import { useBOMStore } from "../../../hooks/bom";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
const bomId = System.getParams().bomId;

const BomCreateProjectPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [status, SetStatus] = useState(false);
    const [projectName, SetProjectName] = useState('');
    const [projectNameError, SetProjectNameError] = useState('');
    const [projectNameErrorStatus, SetProjectNameErrorStatus] = useState(false);
    const [{ latest_system_notification_UUID, latest_system_notification_name, BomCreateProjectPopup }, {}, {}] = useDOMAttachToSystemStore();
    const [{ }, { }, { create_project }] = useBOMProjectStore();
    const [{ }, { get_bom_detail_by_bom_id }, { }] = useBOMStore();
    const [{ }, { fetch_bom_project_detail_with_bom }, { }] = useBOMProjectStore();
    useEffect(() => {
        if (latest_system_notification_name === 'BomCreateProjectPopup') {
            SetStatus(true)
        } else {
            SetStatus(false)
        }
    }, [latest_system_notification_UUID]);
    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onProjectNameChange = async (value) => {
        SetProjectName(value);
        if (projectNameErrorStatus === true) {
            if (value.trim().length === 0) {
                SetProjectNameError('The input Project Name is Invalid')
            } else if (projectName.trim().length > 100) {
                SetProjectNameError('The input Project Name is Invalid')
            } else {
                SetProjectNameErrorStatus(false)
            }
        }
    }
    const createProjectNow = async () => {
        let error = false
        if (projectName.trim().length === 0) {
            error = true;
            SetProjectNameErrorStatus(error)
            SetProjectNameError('The input Project Name is Invalid')
        } else if (projectName.trim().length > 100) {
            error = true;
            SetProjectNameErrorStatus(error)
            SetProjectNameError('The maximum characters supported is 100')
        } else {
            error = false
            SetProjectNameErrorStatus(error)
        }

        if (!error) {
            await create_project({ projectName, bomId });
            await fetch_bom_project_detail_with_bom();
            onHide()
            await get_bom_detail_by_bom_id({ bomId })
            SetProjectName('');
            if (BomCreateProjectPopup.props_afterBOMCreation !== undefined) {
                await BomCreateProjectPopup.props_afterBOMCreation();
            }
            System.alert('Project Created');
        }
    };

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>

                <div className="avnet-modal">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header pb-2">
                            <h4 className="modal-title text-center" id="myModalLabel">Create a Project</h4>
                        </div>
                        <div className="modal-body">
                            <div className="form-group mb-4">
                                <label htmlFor="Name">Project Name*</label>
                                <input type="Name" placeholder='Enter project name' className={projectNameErrorStatus === true && projectNameError ? "form-control form-control-sm error" : "form-control form-control-sm"} id="Name"
                                    value={projectName}
                                    onChange={(e) => {
                                        onProjectNameChange(e.target.value)
                                    }}
                                />
                                <p className="error">{projectNameErrorStatus === true && projectNameError}</p>
                            </div>
                        </div>
                        <div className="modal-footer text-center">
                            <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                                onClick={() => {
                                    onHide()
                                }}>Close
                            </button>
                            <button type="button" className="bs5 btn btn-primary w145"
                                onClick={async (e) => { __check(['BOM_PROJECT_OPERATION_API_CALL', 'BOM_PROJECT_API_CALL']).status ? e.preventDefault() : await createProjectNow(); }}>
                            {__check(['BOM_PROJECT_OPERATION_API_CALL', 'BOM_PROJECT_API_CALL']).status &&
                                <>
                                    <i className="fa fa-spinner fa-spin" />
                                </>
                            }
                            {!__check(['BOM_PROJECT_OPERATION_API_CALL', 'BOM_PROJECT_API_CALL']).status &&
                                <>
                                    CREATE A PROJECT
                                </>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
        </>
    )
}

export default BomCreateProjectPopup;